import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { roundingOff, currency_symbols } from '../../../../Components/helper';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import { ElementTemplate } from '../TemplateComponent';

const grandTotalPriceBeforeDiscount = 'Grand Total Price (Before Discount)';

const showConditions = (colEle, costIncluded, purchaseOrderState) => {
  return (
    colEle?.enable &&
    ((colEle?.label === 'Shipping Cost' && costIncluded && costIncluded === 'No') ||
      (colEle?.label !== 'Shipping Cost' && colEle?.label !== grandTotalPriceBeforeDiscount) ||
      (colEle?.label === grandTotalPriceBeforeDiscount && purchaseOrderState.totalBeforeDiscount !== purchaseOrderState.totalAfterDiscount))
  );
};

const notZero = (e) => {
  return e === 0 ? null : e;
};

const forPropertyName = (fromPreview, isPublicPoPage, previewData, purchaseOrderState, property) => {
  return fromPreview || isPublicPoPage ? notZero(previewData?.[property]) : notZero(purchaseOrderState?.[property]);
};

export const RenderGrandTotal = (isProductArchived) => {
  const {
    purchaseOrderState: { selectedCurrency, costIncluded },
    purchaseOrderState,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    previewData,
    poAddEditAccess,
  } = usePurchaseOrderState();

  const valueSwitch = (name) => {
    switch (name) {
      case 'Grand Total Units':
        return forPropertyName(fromPreview, isPublicPoPage, previewData, purchaseOrderState, 'totalRatioQuantity');
      case grandTotalPriceBeforeDiscount:
        return forPropertyName(fromPreview, isPublicPoPage, previewData, purchaseOrderState, 'totalBeforeDiscount');
      case 'Grand Total Price (After Discount)':
        return forPropertyName(fromPreview, isPublicPoPage, previewData, purchaseOrderState, 'totalAfterDiscount');
      default:
        return forPropertyName(fromPreview, isPublicPoPage, previewData, purchaseOrderState, 'shippingCost');
    }
  };

  const data = forPropertyName(fromPreview, isPublicPoPage, previewData, purchaseOrderState, 'templateJsonSchema');

  return data?.map((element, i) => {
    return (
      element.key === 'Grand_Total' && (
        <Card className="listing-card" key={`${element?.key}_${element?.id}_${i}`}>
          <Card.Header className="px-2 py-2 bgcolor-dark">
            <strong>{element?.label}</strong>
          </Card.Header>
          <Card.Body className="py-4">
            {element?.columns?.map((colElement, rowI) => {
              const eleKey = colElement;
              return (
                <Row key={eleKey} className="span_font_size">
                  {colElement?.map((colEle, index) => {
                    return (
                      colEle.label !== grandTotalPriceBeforeDiscount && (
                        <Col lg={6} key={`${element?.key}_${element?.id}_${rowI}_${index}`}>
                          <div className="d-flex py-1">
                            {showConditions(colEle, costIncluded, purchaseOrderState) && (
                              <ElementTemplate
                                keys={colEle?.key}
                                name={colEle?.label}
                                placeHolder={colEle?.placeholder}
                                label={
                                  (purchaseOrderState.totalBeforeDiscount === purchaseOrderState.totalAfterDiscount &&
                                    colEle?.label === 'Grand Total Price (After Discount)' &&
                                    'Grand Total Price') ||
                                  colEle?.label
                                }
                                disable
                                isProductArchived={isProductArchived}
                                requiredField={colEle?.required}
                                value={
                                  valueSwitch(colEle?.label)
                                    ? new Intl.NumberFormat().format(roundingOff(valueSwitch(colEle?.label), 2))
                                    : valueSwitch(colEle?.label)
                                }
                                onlyRead
                              />
                            )}
                            {showConditions(colEle, costIncluded, purchaseOrderState) && colEle?.showCurrency && (
                              <div className="align-value">
                                <span className="px-1">
                                  {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                                </span>
                              </div>
                            )}
                          </div>
                        </Col>
                      )
                    );
                  })}
                </Row>
              );
            })}
          </Card.Body>
        </Card>
      )
    );
  });
};

export default RenderGrandTotal;
